import { appendAll } from '../../Chunk/dist/effect-Chunk.esm.js';
import { Tag } from '../../Context/dist/effect-Context.esm.js';
import { isLeft, left, isRight, right } from '../../Either/dist/effect-Either.esm.js';
import { symbol as symbol$1, equals } from '../../Equal/dist/effect-Equal.esm.js';
import { pipe } from '../../Function/dist/effect-Function.esm.js';
import { symbol, combine, hash } from '../../Hash/dist/effect-Hash.esm.js';
import { union, empty } from '../../HashSet/dist/effect-HashSet.esm.js';

/**
 * @since 2.0.0
 */
/** @internal */
const TestAnnotationSymbolKey = "effect/TestAnnotation";

/**
 * @since 2.0.0
 */
const TestAnnotationTypeId = /*#__PURE__*/Symbol.for(TestAnnotationSymbolKey);

/**
 * @since 2.0.0
 */

/**
 * @since 2.0.0
 */

/** @internal */
class TestAnnotationImpl {
  [TestAnnotationTypeId] = TestAnnotationTypeId;
  constructor(identifier, tag, initial, combine) {
    this.identifier = identifier;
    this.tag = tag;
    this.initial = initial;
    this.combine = combine;
  }
  [symbol]() {
    return pipe(hash(TestAnnotationSymbolKey), combine(hash(this.identifier)), combine(hash(this.tag)));
  }
  [symbol$1](that) {
    return isTestAnnotation(that) && this.identifier === that.identifier && equals(this.tag, that.tag);
  }
}

/**
 * @since 2.0.0
 */
const isTestAnnotation = u => {
  return typeof u === "object" && u != null && TestAnnotationTypeId in u;
};

/**
 * @since 2.0.0
 */
const make = (identifier, tag, initial, combine) => {
  return new TestAnnotationImpl(identifier, tag, initial, combine);
};

/**
 * @since 2.0.0
 */
const compose = (left$1, right$1) => {
  if (isLeft(left$1) && isLeft(right$1)) {
    return left(left$1.left + right$1.left);
  }
  if (isRight(left$1) && isRight(right$1)) {
    return right(pipe(left$1.right, appendAll(right$1.right)));
  }
  if (isRight(left$1) && isLeft(right$1)) {
    return right$1;
  }
  if (isLeft(left$1) && isRight(right$1)) {
    return right$1;
  }
  throw new Error("BUG: TestAnnotation.compose - please report an issue at https://github.com/Effect-TS/io/issues");
};

/**
 * @since 2.0.0
 */
const fibers = /*#__PURE__*/make("fibers", /*#__PURE__*/Tag(), /*#__PURE__*/left(0), compose);

/**
 * An annotation which counts ignored tests.
 *
 * @since 2.0.0
 */
const ignored = /*#__PURE__*/make("ignored", /*#__PURE__*/Tag( /*#__PURE__*/Symbol.for("effect/TestAnnotation/ignored")), 0, (a, b) => a + b);

/**
 * An annotation which counts repeated tests.
 *
 * @since 2.0.0
 */
const repeated = /*#__PURE__*/make("repeated", /*#__PURE__*/Tag( /*#__PURE__*/Symbol.for("effect/TestAnnotation/repeated")), 0, (a, b) => a + b);

/**
 * An annotation which counts retried tests.
 *
 * @since 2.0.0
 */
const retried = /*#__PURE__*/make("retried", /*#__PURE__*/Tag( /*#__PURE__*/Symbol.for("effect/TestAnnotation/retired")), 0, (a, b) => a + b);

/**
 * An annotation which tags tests with strings.
 *
 * @since 2.0.0
 */
const tagged = /*#__PURE__*/make("tagged", /*#__PURE__*/Tag( /*#__PURE__*/Symbol.for("effect/TestAnnotation/tagged")), /*#__PURE__*/empty(), (a, b) => pipe(a, union(b)));

export { TestAnnotationTypeId, compose, fibers, ignored, isTestAnnotation, make, repeated, retried, tagged };
